<template>
  <div>
    <form class="p-4m" @submit.prevent="submitForm">
      <div class="px-3 pt-3 pb-1 mb-3 border rounded-bottom tab-container">
        <h5>
          {{ $t(`dashboard-settings.mypage-message-1`) }}
        </h5>
        <div class="row">
          <div class="col-sm-12">
            <div>
              <b-tabs>
                <b-tab
                  v-for="(lang, index) in languages"
                  :key="`lang_${index}`"
                  :title="$languages[lang.code]"
                  :active="language_data == lang.code"
                  @click="() => showMessageText(lang.code)"
                  >
                </b-tab>
              </b-tabs>
            </div>
            <div class="px-3 pt-3 pb-1 border rounded-bottom editor-container">
              <b-form-textarea
                class="form-control"
                rows="5"
                :state="messageText.length <= 1000 ? null : false"
                v-model="messageText"
              />
              <div class="d-flex pt-2 pb-1 justify-content-between">
                <div class="editor-footnote">
                  <small> {{ messageText.length }} / 1000  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12" align="right">
          <button
            type="submit"
            class="btn btn-warning btn-wide"
            :disabled="messageText.length > 1000"
          >
            <i class="fas fa-save mr-1"></i>
          {{ $t("dashboard-common.word-save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import settingsApi from "@/api/settings";
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["languages"]),
    ...mapGetters("dashboard", ["facility"])
  },
  data() {
    return {
      data: {
        facility_id: null,
        name: "",
        value: ""
      },
      language_data: "ja",
      messageText: "",
    };
  },
  beforeMount() {
    this.data.facility_id = this.facility.id;
  },
  async mounted() {
    this.showMessageText(this.$i18n.locale);
  },
  methods: {
    async showMessageText(lang) {
      try {
        this.language_data = lang;
        const response = await settingsApi.getMyPageA(this.facility.id, lang);
        const data =
          {
            facility_id: this.facility.id,
            name: `mypage-A-${lang}`,
            value: response.data[0] ? response.data[0].value : "",
          };
        this.data = data;
        this.messageText = data.value;
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },
    async submitForm(e) {
      try {
        await settingsApi.save(this.data);
        this.$toast.success(this.$t("dashboard-common.updated-generic"), {
          position: "top"
        });
      } catch (e) {
        console.error(e);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    }
  },
  watch: {
    "messageText"(v) {
      this.data.value = v;
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-footnote {
  line-height: 31px;
}
</style>
